export default class CustomError extends Error {
    constructor(message, name) {
        super(message)
        this.message = message || 'An unhandled error has occurred'
        this.stack = new Error(name || 'CustomError').stack
    }
}
